import { defaults, ResourceDescriptor } from "./common";

const simplified_user: ResourceDescriptor = {
    url: "simplified_user",
    orders: {
        update: ["given_name", "family_name", "gender", "birthdate", "locale"],
    },
    crudActions: ["update"],
    listDefaults: defaults.list,
    identifiers: ["name"],
    expand: {},
};

export default simplified_user;
